<template>
  <div class="page">
    <MainHeader v-bind:page="'Home'"></MainHeader>
    <div class="container">
      <div class="row">
        <div class="whole component">
          <img :src="headerImage" width="938px" />
          <h1>Herberg van het Hart</h1>
          <h3>
            De schat die iemand in zijn diepste kern is helpen zichtbaar,
            hoorbaar en ervaarbaar te maken.<br />
            ~ Suzette Frijters ~
          </h3>
        </div>
      </div>
    </div>
    <!-- <MainFooter
      style="display:flex; margin-left: auto; margin-right:auto;"
    ></MainFooter> -->
  </div>
</template>

<script>
import MainHeader from "../MainHeader";
import MainFooter from "../MainFooter";

export default {
  name: "demo",
  data() {
    return {
      headerImage: require("../../img/home_header.jpg")
    };
  },
  computed: {},
  methods: {},
  components: {
    MainHeader,
    MainFooter
  }
};
</script>



// WEBPACK FOOTER //
// src/components/pages/Home.vue